import FabricationSequenceStore from "./FabricationSequence/FabricationSequenceStore";
import CastingMapStore from "./CastingMap/CastingMapStore";
import ProductionMonitorStore from "./ProductionMonitor/ProductionMonitor.Store";
import HoldManagementStore from "./HoldManagement/HoldManagement.Store";
import MoldEngineerAssignmentStore from "./MoldEngineerAssignment/MoldEngineerAssignment.Store";
import TrailerLoadViewStore from "./trailer-load-builder/stores/TrailerLoadViewStore";

const productionStoreList = [
  { name: "fabricationSequenceStore", store: FabricationSequenceStore },
  { name: "castingMapStore", store: CastingMapStore },
  { name: "productionMonitorStore", store: ProductionMonitorStore },
  { name: "holdManagementStore", store: HoldManagementStore },
  { name: "moldEngineerAssignmentStore", store: MoldEngineerAssignmentStore },
  { name: "trailerLoadViewStore", store: TrailerLoadViewStore },
];

export default productionStoreList;
